import { render, staticRenderFns } from "./Server.vue?vue&type=template&id=4debaca0&scoped=true"
import script from "./Server.vue?vue&type=script&lang=js"
export * from "./Server.vue?vue&type=script&lang=js"
import style0 from "./Server.vue?vue&type=style&index=0&id=4debaca0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4debaca0",
  null
  
)

export default component.exports